import { useState, useEffect, forwardRef } from 'react'
import "./Challenges.css"
import Axios from 'axios';
import MuiAlert from '@mui/material/Alert';
import Cookies from 'universal-cookie';
import { Card, CardContent, CardMedia, Button, Typography, CardActions, LinearProgress, Box, Snackbar } from '@material-ui/core';
import { useHistory } from 'react-router';
import { Typewriter } from 'react-simple-typewriter'
import { useTimer } from 'react-timer-hook';
const Challenges = () => {


    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const [categories, setCategories] = useState([])
    const [showChalls, setShowChalls] = useState(false)
    const [secondTable, setSecondTable] = useState(false)
    const [competition, setCompetition] = useState(false)
    const [consoleMessage, setConsoleMessage] = useState('')
    const [time, setTime] = useState(new Date());
    const history = useHistory();

    useEffect(() => {

        Axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/challenges/getActiveCategories`, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (response.data.messageFinish) {
                    setCompetition(false)
                    setConsoleMessage('La competencia ha finalizado.')
                    setCategories([]);
                }
                else if (response.data.messageInit) {
                    setCompetition(false)
                    setConsoleMessage('La competencia aún no ha iniciado.')
                    setCategories([]);
                }
                else if (response.data.messageNot) {
                    setCompetition(false)
                    setConsoleMessage('No hay competencia activa.')
                    setCategories([]);
                }
                else {
                    Axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settings/getTimersUser`, {
                        headers: { 'Authorization': userToken }
                    }).then(res => {
                        if (res.data.running) {
                            time.setSeconds(time.getSeconds() + res.data.totalSeconds);
                            setCategories(response.data)
                            setCompetition(true)
                           
                        }
                        else{
                            setCategories(response.data)
                            setCompetition(false)
                        }
                    });
                }
            }
        });
    }, []);
    function MyTimer({ expiryTimestamp}) {
        
        const {
            seconds,
            minutes,
            hours,
            days,
        } = useTimer({ expiryTimestamp, onExpire: () => console.warn('onExpire called') });
        

        return (
            <div className="timer-chall" >
                <div className="time-card-begin-chall">{days}<div className="time-desc-chall">días</div></div>
                <div className="time-card-chall">{hours}<div className="time-desc">horas</div></div>
                <div className="time-card-chall">{minutes}<div className="time-desc-chall">minutos</div></div>
                <div className="time-card-chall">{seconds}<div className="time-desc-chall">segundos</div></div>
            </div>
        );
    }

    function showCategories(change) {
        let items2 = []
        let items3 = []
        for (let [ky, val] of Object.entries(categories)) {
            if (ky < 6) {
                items2.push(<Card
                    className="cardWdithCursor"
                    onClick={(e) => {
                        history.push('/user/retos/' + val.category_id)
                    }}>
                    <CardMedia className="cardMediaWidthHeight"
                        component="img"
                        alt="imagen categoría"
                        height="10"
                        image={val.location}
                    />
                    <CardContent className="cardContentWidthHeight" >
                        <Typography gutterBottom component="div" variant="h6" className="typographyStyling">
                            {
                                val.title
                            }
                        </Typography>
                        <Typography variant="body2" color="text.secondary" className="typographyStyling2">
                            {
                                val.description
                            }
                        </Typography>
                        <Box className="boxDisplayFlex">
                            <Box className="boxColorWidth" >
                                <LinearProgress
                                    variant="determinate"
                                    value={(val.totalChallenges === 0) ? 0 : (val.totalSolves * 100 / val.totalChallenges)}
                                    color="primary"
                                />
                            </Box>
                            <Box className="boxWidthMargin">
                                <Typography variant="body3" color="text.secondary">{val.totalSolves}/{val.totalChallenges}</Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>)
            }
            else {
                items3.push(<Card
                    className="cardWdithCursor"
                    onClick={(e) => {
                        history.push('/user/retos/' + val.category_id)
                    }}>
                    <CardMedia className="cardMediaWidthHeight" 
                        component="img"
                        alt="imagen categoría"
                        height="140"
                        image={val.location}
                        width="100%"
                    />
                    <CardContent className="cardContentWidthHeight" >
                        <Typography gutterBottom component="div" variant="h6" className="typographyStyling">
                            {
                                val.title
                            }
                        </Typography>
                        <Typography variant="body2" color="text.secondary" className="typographyStyling2">
                            {
                                val.description
                            }
                        </Typography>
                        <Box className="boxDisplayFlex">
                            <Box className="boxColorWidth" >
                                <LinearProgress
                                    variant="determinate"
                                    value={(val.totalChallenges === 0) ? 0 : (val.totalSolves * 100 / val.totalChallenges)}
                                    color="primary"
                                />
                            </Box>
                            <Box className="boxWidthMargin" >
                                <Typography variant="body3" color="text.secondary">{val.totalSolves}/{val.totalChallenges}</Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>)
            }
        }
        if (change === 'primary') {
            return (items2)
        }
        else {
            return (items3)

        }

    }
    function consoleDisplay() {
        return (
            <div className="screenMessage" >
                <div className="window" >
                    <div className="controls">
                        <div className="buttons close" />
                        <div className="buttons maximize" />
                        <div className="buttons minimize" />
                        <div className="title">Gnome Terminal</div>
                    </div>
                    <div className="bash">
                        <span id="span">[${process.env.REACT_APP_BASE_URL} ~]:$ ./iniciar</span>
                        <br />
                        <div className="type-it">
                            <Typewriter
                                words={['Hola!', consoleMessage, 'Pero..........', 'Mientras tanto puedes practicar en la sección de aprendizaje!']}
                                loop={5}
                                cursor
                                cursorStyle='_'
                                typeSpeed={70}
                                deleteSpeed={50}
                                delaySpeed={1000}
                                className={ competition ? "displayNone" : ""}
                            />

                        </div>
                        <br />
                    </div>
                </div>


            </div>

        )
    }


    return (
        <>
            <div className="screen-challenges"  >
                <div className={ competition ? "dashboard visible" : "dashboard displayNone2"}>
                    <div className={ showChalls ? "categories-screen displayNone" : "categories-screen"}>
                        {secondTable ? showCategories('secondary') : showCategories("primary")}
                    </div>
                    <div className={ showChalls ? "dashboard-button displayNone" : "dashboard-button"}><button className={ secondTable ? "dash-btn-left" : "dash-btn-left buttonDisplayNone"} onClick={(e) => { setSecondTable(false) }}>Anterior</button>
                        <button className={ secondTable ? "dash-btn-right displayNone" : "dash-btn-right buttonDisplayStyle"} onClick={(e) => { setSecondTable(true) }}>Siguiente</button></div>
                </div>
                <div className={ competition ? "right-screen visible" : "right-screen displayNone2"}>
                    <div className="challenge-card" >
                        <div className="divStyling">
                            <img src="/arrowLeft.png" alt="<===" className="imgStyling" />
                            <p className="paragraphStyling">Selecciona una categoría para ver los retos.</p>
                    </div>
                    <div className="card-instructions">
                    <p >- Las categorías con 0/0 no tienen retos.</p>
                    <br />
                    <p>- Los retos van apareciendo en el transcurso 
                        de la competencia, el indicador de la derecha
                        indica el número de retos habilitados de la categoría, por ejemplo 0/1.
                    </p>
                    <br />
                    <p>- El indicador de la izquierda muestra el número de retos resueltos. </p>          
                    </div>
                    <div className="divStyling2">
                            <p className="paragraphStyling">Duración de la competencia</p>
                            <img src="/arrowDown.png" alt="<===" className="imgStyling" />
                    
                    </div>
                    </div>
                    <div className="timer-card-chall" >
                        <MyTimer expiryTimestamp={time} />
                    </div>

                </div>
                <div className={ competition ? "screenChallenge displayNone2" : "screenChallenge"}>
                    {competition ? "" : consoleDisplay()}
                </div>
            </div>
        </>

    )
}

export default Challenges
